import React from 'react';
import { ReactComponent as TooltipIcon } from '../assets/icons/tooltip.svg';
import { colors } from '../global/variables';

export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';
export type TooltipVariant =
    | 'default'
    | 'light'
    | 'success'
    | 'warning'
    | 'error';
export type TooltipSize = 'small' | 'default' | 'large';

interface TooltipProps {
    content: string | React.ReactNode;
    position?: TooltipPosition;
    variant?: TooltipVariant;
    size?: TooltipSize;
    delay?: boolean;
    animated?: boolean;
    alwaysVisible?: boolean;
    multiline?: boolean;
    icon?: React.ReactNode;
    iconColor?: string;
    iconStroke?: string;
    className?: string;
    children?: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({
    content,
    position = 'top',
    variant = 'default',
    size = 'default',
    delay = false,
    animated = false,
    alwaysVisible = false,
    multiline = false,
    icon,
    iconColor = colors.inactiveWhite,
    iconStroke = colors.inactiveWhite,
    className = '',
    children,
}) => {
    // Build CSS classes
    const containerClasses = [
        'tooltip-container',
        position !== 'top' && `tooltip-${position}`,
        variant !== 'default' && `tooltip-${variant}`,
        size !== 'default' && `tooltip-${size}`,
        delay && 'tooltip-delay',
        animated && 'tooltip-animated',
        alwaysVisible && 'tooltip-always-visible',
        multiline && 'tooltip-multiline',
        className,
    ]
        .filter(Boolean)
        .join(' ');

    // Default icon if none provided
    const defaultIcon = icon || (
        <TooltipIcon
            className="session__icon-medium"
            fill={iconColor}
            stroke={iconStroke}
            style={{ paddingBottom: 2 }}
        />
    );

    return (
        <div className={containerClasses}>
            {children || defaultIcon}
            <div className="tooltip-content">{content}</div>
        </div>
    );
};

export default Tooltip;
